'use client'

import { Text, VStack } from '@chakra-ui/react'
import React from 'react'

const VideoItem = ({ url, title }: { url: any; title: string }) => {
  return (
    <VStack w={'100%'} alignItems={'start'}>
      <Text textStyle={'videosTitle'} textTransform={'uppercase'}>
        {title}
      </Text>
      <video
        controls
        autoPlay
        muted
        width="100%"
        style={{ aspectRatio: '16/9' }}
      >
        <source src={url} type="video/mp4" />
      </video>
    </VStack>
  )
}

export default VideoItem
